import React, { PureComponent } from 'react';
import CodeMirror from 'codemirror';

import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/search/search';
import 'codemirror/addon/search/searchcursor';
import 'codemirror/addon/search/jump-to-line';
import 'codemirror-graphql/results/mode';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/dracula.css';
import 'codemirror/addon/fold/foldgutter.css';

class ResultViewer extends PureComponent {
    componentDidMount() {
        this.viewer = CodeMirror(this._node, {
            lineWrapping: true,
            value: this.props.value || '',
            readOnly: true,
            theme: 'dracula',
            mode: 'graphql-results',
            foldGutter: {
                minFoldSize: 4,
            },
            lineNumbers: true,
            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
        });
    }

    componentDidUpdate() {
        this.viewer.setValue(this.props.value || '');
    }

    componentWillUnmount() {
        this.viewer = null;
    }

    render() {
        return (
            <div className="result-viewer"
                ref={node => {
                    this._node = node;
                }}
            />
        );
    }
}

export default ResultViewer;



// WEBPACK FOOTER //
// ./src/components/ResultViewer.js